import * as React from 'react';
export const IcAdventure = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.87 19.5l-2.87-5a1 1 0 00-1.73 0l-1.51 2.61L10.63 10V8.5h3.67a1 1 0 00.89-.5 1 1 0 00-.07-1l-.65-1 .66-1a1 1 0 000-1 1 1 0 00-.88-.53h-3.8A1 1 0 009.63 3a1 1 0 00-1 1v6l-5.5 9.5A1 1 0 004 21h16a1 1 0 00.87-1.5z'
      fill='currentColor'
    />
  </svg>
);
